import { FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material';

import { Icon } from '../icons';

import { CheckboxProps } from './types';

export const Checkbox = ({ label, ...props }: CheckboxProps) => {
  return (
    <FormControlLabel
      label={label}
      control={
        <MuiCheckbox
          {...props}
          disableRipple
          icon={<Icon.CheckboxOff />}
          checkedIcon={<Icon.CheckboxOn />}
        />
      }
    />
  );
};
